// extracted by mini-css-extract-plugin
module.exports = {"Landing":"Landing_Landing__1wCT2","Content":"Landing_Content__3D3MF"};